<template>
    <div class="news-content" >
        <div class="news-info">
            <h2>{{news.title}}</h2>
            <p>{{news.createtime}}<span><i class="iconfont icon-yanjing"></i>{{news.views}}</span></p>
            <div class="news-text" v-html="news.content"></div>
            <p>-&nbsp;THE&nbsp;END&nbsp;-</p>
        </div>
        <!--<div class="other-news">
            <p>上一篇&nbsp;:&nbsp;前端高级开发工程师</p>
            <p>下一篇&nbsp;:&nbsp;iOS中级开发工程师</p>
        </div>-->
    </div>
</template>

<script>
export default {
    name: 'NewsContent',
    props: {
        news: Object
    },
    data () {
        return {
            
        }
    },
    methods: {
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        imgShow (str) {
            var reg = new RegExp(/(src=")([^"]*")/g)
            var arr = reg.exec(str)
            if(!arr){
                return str
            }
            else{
                return str.replace(reg,"$1https://guanwang.wsandos.com$2")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .news-text >>> img
        width: 100%
    .news-content
        width: 100%
        .news-info
            padding: 8% 4% 0.22rem
            box-size: border-box
            border-bottom: 1px solid #eee
            margin-bottom: 4%
            h2
                font-size: 0.42rem
                font-weight: 800
                line-height: 1.3em
                letter-spacing: 1px
                color: $black
            p:first-of-type
                margin-top: 0.54rem
                margin-bottom: 0.52rem
                font-size: 0.24rem
                color: #7e8795
                padding-bottom: 0.48rem
                border-bottom: 1px solid #f5f5f5
            span
                float: right
                font-size: 0.24rem
                color: #666
                i
                    margin-right: 0.1r     em
                    font-size: 0.24rem
                    color: #9198a4
            .news-text
                width: 100%
                padding-bottom: 20%
            p:last-of-type
                margin-top: 3em
                text-align: center
                font-size: 0.25rem
                color: #333
        .other-news
            padding: 0 4% 10%
            font-size: 0.36rem
            line-height: 2em
</style>


// WEBPACK FOOTER //
// src/components/mobile/NewsContent.vue